import React from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Fade() {
  const settings = {
    dots: false,
    fade: true,
    arrows: false,
    infinite: true,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    waitForAnimate: false,
  };
  return (
    <div className="slider-container md:h-screen z">
      <Slider {...settings}>
        <div className="md:h-screen md:w-full opacity-100">
          <h1 className="text-7xl absolute text-white px-4 shadow-2xl opacity-100 text-center md:pt-96 pt-48 font-bold z-50 w-full h-full">
            {" "}
            SOUTH GLOBAL EXIM{" "}
          </h1>
          <div className="bg-black absolute h-screen w-full z-10 bg-opacity-50">
            {" "}
          </div>
          <img
            src="https://images.pexels.com/photos/3856440/pexels-photo-3856440.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
            className="w-full md:h-screen md:object-fit h-[80vh] object-cover"
            alt="image_name"
          />
        </div>
        <div>
          <h1 className="text-7xl absolute text-white px-4 opacity-100 text-center md:pt-96 pt-48 font-bold z-40 w-full h-full">
            WELCOMES YOU{" "}
          </h1>
          <div className="bg-black absolute h-screen w-full z-10 bg-opacity-50">
            {" "}
          </div>
          <img
            src="./SliderImages/4.jpeg"
            className="w-full md:h-screen md:object-fit h-[80vh] object-cover"
            alt="image_name"
          />
        </div>
        <div>
          <h1 className="text-7xl absolute text-white shadow-2xl px-4 opacity-100 text-center md:pt-96 pt-48 font-bold z-40 w-full h-full">
            {" "}
            SOUTH GLOBAL EXIM{" "}
          </h1>
          <div className="bg-black absolute h-screen w-full z-10 bg-opacity-50">
            {" "}
          </div>
          <img
            src="./SliderImages/3.jpeg"
            className="w-full md:h-screen md:object-fit h-[80vh] object-cover"
            alt="image_name"
          />
        </div>
        <div>
          <h1 className="text-7xl absolute text-white px-4 opacity-100 text-center md:pt-96 pt-48 font-bold z-40 w-full h-full">
            WELCOMES YOU{" "}
          </h1>
          <div className="bg-black absolute h-screen w-full z-10 bg-opacity-50">
            {" "}
          </div>
          <img
            src="./SliderImages/4.jpeg"
            className="w-full md:h-screen md:object-fit h-[80vh] object-cover"
            alt="image_name"
          />
        </div>
      </Slider>
    </div>
  );
}
